import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Dispatch store actions
import { actions } from "@/redux/reducers/User";

// Subscriptions
import { useSubscriptions } from "@/Common/context/subscriptions/Subscriptions";
import { resolveUserSubscriptionPipeline } from "@/Layouts/views/Header/subscriptions/pipelines";
import {
	onAddUserAuthorizationCallback,
	onAddUserAuthorizationLocationCallback,
	onDeleteUserAuthorizationCallback,
	onDeleteUserAuthorizationLocationCallback,
	onDeleteUserGroupCallback,
	onGroupAccessModificationsCallback,
} from "@/Layouts/views/Header/subscriptions/callbacks";

export const useUserSubscriptions = (props) => {
	const { tenant = "" } = props;
	const user = useSelector((state) => state.user.user);
	const location = useSelector((state) => state.location.location);

	const dispatch = useDispatch();
	const { addSubscription, getSubscription } = useSubscriptions();

	const userSubscription = getSubscription(["generalUserSubscriptions", user?._id]);

	userSubscription?.subscriptions?.onUpdateUserProfilePicture?.setCallback((result) => {
		const response = result.data?.onUpdateUserProfilePicture || {};
		const { presignedProfilePicture } = response;
		if (presignedProfilePicture) {
			const updated = { ...user, profilePicture: presignedProfilePicture };
			dispatch(actions.SET_USER({ user: updated }));
		}
		return null;
	});

	userSubscription?.subscriptions?.onAddUserAuthorization.setCallback((result) =>
		onAddUserAuthorizationCallback({ localUser: user, result, dispatch, location })
	);

	userSubscription?.subscriptions?.onDeleteUserAuthorization.setCallback((result) =>
		onDeleteUserAuthorizationCallback({ localUser: user, result, dispatch, location })
	);

	userSubscription?.subscriptions?.onAddUserAuthorizationLocation.setCallback((result) =>
		onAddUserAuthorizationLocationCallback({ localUser: user, result, dispatch, location })
	);

	userSubscription?.subscriptions?.onDeleteUserAuthorizationLocation.setCallback((result) =>
		onDeleteUserAuthorizationLocationCallback({ localUser: user, result, dispatch, location })
	);

	userSubscription?.subscriptions?.onDeleteUserGroup.setCallback((result) => {
		onDeleteUserGroupCallback({ localUser: user, result, dispatch, location });
	});

	userSubscription?.subscriptions?.onGroupAccessModifications.setCallback((result) =>
		onGroupAccessModificationsCallback({ localUser: user, result, dispatch, location })
	);

	userSubscription?.subscriptions?.onGlobalDeleteUserGroup.setCallback((result) =>
		onDeleteUserGroupCallback({ localUser: user, result, dispatch, location })
	);

	userSubscription?.subscriptions?.onGlobalGroupAccessModifications.setCallback((result) =>
		onGroupAccessModificationsCallback({ localUser: user, result, dispatch, location })
	);

	useEffect(() => {
		if (location && user) {
			addSubscription(
				["generalUserSubscriptions", user._id],
				resolveUserSubscriptionPipeline({ localUser: user, location, tenant }),
				true
			);
		}
		return () => {};
	}, [location, user, addSubscription]);
};
